'use client'

// React Imports
import { useEffect, useState } from 'react'

const useMediaQuery = (breakpoint?: string): boolean => {
  // States
  const [matches, setMatches] = useState(breakpoint === 'always')

  useEffect(() => {
    if (breakpoint && breakpoint !== 'always') {
      const bp = breakpoint.trim()
      const query = bp.startsWith('@media') ? bp.replace(/^@media\s*/g, '').trim() : /^\(.*\)$/.test(bp) ? bp : `(max-width: ${bp})`
      const media = window.matchMedia(query)

      if (media.matches !== matches) {
        setMatches(media.matches)
      }

      const listener = (e: MediaQueryListEvent) => setMatches(e.matches)

      media.addEventListener('change', listener)

      return () => media.removeEventListener('change', listener)
    }
  }, [matches, breakpoint])

  return matches
}

export default useMediaQuery
